export default __webpack_public_path__ + "static/media/excess.bc23e92c.svg";